import { NeedDto } from '@act/shared/data-transfer-objects';
import { Box, useTheme } from '@mui/material';
import HtmlDisplayer from 'react-components/components/HtmlDisplayer';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hook';
import { InfoContainer, LabeledDatum } from '@act/toolkit/styles/DataDisplay';

interface Props {
  need: NeedDto;
}

export const NeedMiniInfoBox = ({ need }: Props) => {
  const theme = useTheme();
  const needMetadata = metaSliceSelectors.useSelectNeedsMetadata();
  const issue = needMetadata?.data?.issues.find(i => i.id === need.issueId);
  const category = needMetadata?.data?.categories.find(
    c => c.id === issue?.categoryId
  );

  return (
    <Box
      sx={{
        margin: '8px 0',
      }}
    >
      <InfoContainer style={{ backgroundColor: theme.palette.navyShades[50] }}>
        <LabeledDatum
          label={'Reason'}
          datum={<HtmlDisplayer innerHtml={need?.reason} />}
        />
        <LabeledDatum label="Category" datum={category?.label} />
        <LabeledDatum label="Issue" datum={issue?.label} />
      </InfoContainer>
    </Box>
  );
};
